module.exports = __webpack_public_path__ + "img/03_Intro_01.960bb422.jpg";